// extracted by mini-css-extract-plugin
module.exports = {"spanIconContainerNormal":"ActivityIcon_spanIconContainerNormal__PUPgP","spanIconContainerSmall":"ActivityIcon_spanIconContainerSmall__q8cqZ"};